module.exports = __webpack_public_path__ + "static/img/2.6013e68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-es/2.jpg
// module id = eAuL
// module chunks = 1